import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vencuadredecaja',
  templateUrl: './vencuadredecaja.component.html',
  styleUrls: ['./vencuadredecaja.component.css']
})
export class VencuadredecajaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
